export default __webpack_public_path__ + "static/media/editPencil.607622c5.svg";